import { useMemo, useState } from 'react';

import curry from 'ramda/src/curry';

import { EocError, isNetworkError, useReportError } from '@atlassian/eoc-global-context';

import { type DefaultCatch, type DefaultCatchConfig } from './types';

export function useDefaultCatch() {
	const reportError = useReportError();
	const [error, setError] = useState<EocError>();

	if (error) {
		throw error;
	}

	return useMemo(
		<R>() =>
			curry(
				(
					{ id, httpErrorHandler, reporter: customReporter, attributes }: DefaultCatchConfig<R>,
					error: unknown,
				): R | void => {
					if (!isNetworkError(error)) {
						return setError(new EocError(id, error));
					}

					if (customReporter !== null) {
						const reporter = customReporter ?? reportError;

						reporter(id, error, attributes);
					}

					try {
						return httpErrorHandler?.(error);
					} catch (handlerError) {
						if (!isNetworkError(handlerError)) {
							setError(new EocError(id, handlerError));
						}

						throw handlerError;
					}
				},
			) as DefaultCatch,
		[reportError],
	);
}
